var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuildingUserSm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "building-user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.311,
    height: 12.249,
    viewBox: "0 0 15.311 12.249",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4504",
    "data-name": "Path 4504",
    d: "M355.445,195.828a1.914,1.914,0,1,0-1.914-1.914A1.914,1.914,0,0,0,355.445,195.828Zm-1.218.766A2.228,2.228,0,0,0,352,198.82a.834.834,0,0,0,.835.835h5.22a.834.834,0,0,0,.835-.835,2.228,2.228,0,0,0-2.227-2.227Z",
    transform: "translate(-343.579 -187.407)",
    fill: "#888",
    opacity: 0.803
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4505",
    "data-name": "Path 4505",
    d: "M0,1.148A1.149,1.149,0,0,1,1.148,0h6.89A1.149,1.149,0,0,1,9.186,1.148V8.8a2.991,2.991,0,0,0-1.531,2.612,1.591,1.591,0,0,0,.237.84H5.741V10.335a1.148,1.148,0,1,0-2.3,0v1.914h-2.3A1.149,1.149,0,0,1,0,11.1Zm1.914,4.21a.384.384,0,0,0-.383.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V5.741a.384.384,0,0,0-.383-.383Zm1.914.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V5.741a.384.384,0,0,0-.383-.383H4.21A.384.384,0,0,0,3.828,5.741Zm2.679-.383a.384.384,0,0,0-.383.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V5.741a.384.384,0,0,0-.383-.383ZM1.531,2.679v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V2.679A.384.384,0,0,0,2.679,2.3H1.914A.384.384,0,0,0,1.531,2.679ZM4.21,2.3a.384.384,0,0,0-.383.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V2.679A.384.384,0,0,0,4.976,2.3Zm1.914.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V2.679A.384.384,0,0,0,7.273,2.3H6.507A.384.384,0,0,0,6.124,2.679Z",
    fill: "#0d47a1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuildingUserSm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/building-user-sm.c6f700b5111b7452576d8e2b4a73e889.svg";